import { TApplicationState } from '../../types/redux';

export function getAdvantages(state: TApplicationState) {
  return state.newbuilding.advantages;
}
